@if (componentData.data$ | async; as component) {
  <div class="homepage-hero">
    <boels-media
      [fetchPriority]="ImageFetchPriority.HIGH"
      [container]="component.media"
      [alt]="component.title"
      [loading]="ImageLoadingStrategy.EAGER"
    ></boels-media>
    <boels-vertical-aligner class="homepage-hero__search">
      <h1>{{ component.title }}</h1>
      <div class="homepage-hero__search-content-wrapper">
        <div
          class="homepage-hero__search-content"
          [ngClass]="{ 'remove-bottom-radius': hasSearchResults }"
        >
          @if (activeOption === SearchOption.PRODUCT) {
            <boels-custom-searchbox
              [doSearch]="search"
              [isHomepage]="true"
              [searchQueryValue]="searchTerm"
              (searchQueryValueChanged)="updateSearchTerm($event)"
              (searchResultsChanged)="onSearchChange($event)"
            ></boels-custom-searchbox>
          }
          @if (activeOption === SearchOption.BRANCHES) {
            <boels-store-finder-search
              [doSearch]="search"
              [isHomepage]="true"
              [inputValue]="searchTerm"
              (inputChanged)="updateSearchTerm($event)"
            ></boels-store-finder-search>
          }
          <div class="homepage-hero__select">
            <label class="homepage-hero__select-label">
              <select
                tabindex="0"
                class="homepage-hero__select-select"
                (change)="changeOption($event)"
              >
                @for (
                  option of availableOptionLabels | keyvalue;
                  track trackByKey($index, option)
                ) {
                  <option
                    [attr.selected]="activeOption === option.key ? true : null"
                    [value]="option.key"
                    class="ng-option"
                  >
                    {{ option.value | transloco }}
                  </option>
                }
              </select>
            </label>
          </div>
        </div>
        <button
          (click)="callSearch()"
          [attr.aria-label]="$searchButtonTextToSpeech | async"
          class="btn btn-primary homepage-hero__btn-search -homepage"
          [disabled]="activeOption === SearchOption.BRANCHES && !searchTerm"
          boelsQa="search-button"
        >
          <fa-icon [icon]="faSearch" tabindex="-1"></fa-icon>
          @if (isMobile | async) {
            <span>
              {{ 'header.searchBox.search' | transloco }}
            </span>
          }
        </button>
      </div>
    </boels-vertical-aligner>
  </div>
}
